import React, { useState, useEffect } from "react";
import "./DemoLogin.css";
import leftImage from "../assets/h2.png"; 

// import img1 from "../assets/h1.png";
// import img2 from "../assets/h2.png";
// import img3 from "../assets/phone.png";

const slides = [
  {
    title: "Fleets are the bridge that brings us together.",
    desc: "We believe that all commercial vehicles deserve easy access to world-class fleet management solutions."
  },
  {
    title: "Smart Fleet. Smart Business.",
    desc: "Manage your commercial vehicles with powerful tracking and monitoring tools."
  },
  {
    title: "Drive Efficiency with Technology.",
    desc: "Modern solutions designed to improve business productivity and safety."
  }
];

const TechVisionLogin = () => {
  const [index, setIndex] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);

  // Auto Slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  const handleGoogleLogin = () => {
    window.open("http://backup.visionpay@gmail.com", "_self");
  };

  const handleNormalLogin = () => {
    setLoggedIn(true);
  };

  return (
    <div className={`demelogin-main-container ${loggedIn ? "after-login" : ""}`}>
      {/* LEFT SIDE */}
      <div className="demelogin-left">
        <img src={leftImage} className="demelogin-left-bg" alt="background" />

        <div className="demelogin-logo"><span1>T</span1>ech<span>V</span>ision</div>

        <div className="demelogin-left-content fade">
          <h2>{slides[index].title}</h2>
          <p>{slides[index].desc}</p>

          <div className="demelogin-dots">
            {slides.map((_, i) => (
              <span
                key={i}
                className={`demelogin-dot ${i === index ? "active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT SIDE (animated liquid wave background) */}
      <div className="demelogin-right-wrap">
        {/* Animated wave background layer */}
        <div className="demelogin-right-wave-bg" aria-hidden="true">
          {/* SVG used for crisp animated wave — duplicated for parallax */}
          <svg className="demelogin-wave wave1" viewBox="0 0 1200 200" preserveAspectRatio="none">
            <path d="M0,100 C300,200 900,0 1200,100 L1200,200 L0,200 Z" />
          </svg>
          <svg className="demelogin-wave wave2" viewBox="0 0 1200 200" preserveAspectRatio="none">
            <path d="M0,120 C350,20 850,220 1200,120 L1200,200 L0,200 Z" />
          </svg>
        </div>

        {/* Right content area (login card sits inside) */}
        <div className="demelogin-right">
          <div className="demelogin-login-box">
            <h3>Login to your account</h3>

            <div className="demelogin-gmail-box" onClick={handleGoogleLogin}>
              <img
                src="https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg"
                alt="Google G"
                width={36}
                className="demelogin-gmail-logo"
              />
              <span>Continue with Google</span>
            </div>

            <div className="demelogin-divider">
              <span>or</span>
            </div>

            <label>Username</label>
            <input type="text" className="demelogin-input" placeholder="Enter username" />

            <label>Password</label>
            <input type="password" className="demelogin-input" placeholder="Enter password" />

            <button className="demelogin-login-btn" onClick={handleNormalLogin}>
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechVisionLogin;



// import React, { useState, useEffect } from "react";
// import "./DemoLogin.css";

// import img1 from "../assets/h1.png";
// import img2 from "../assets/h2.png";
// import img3 from "../assets/h3.png";

// const slides = [
//   {
//     img: img1,
//     title: "Fleets are the bridge that brings us together.",
//     desc: "We believe that all commercial vehicles deserve easy access to world-class fleet management solutions."
//   },
//   {
//     img: img2,
//     title: "Smart Fleet. Smart Business.",
//     desc: "Manage your commercial vehicles with powerful tracking and monitoring tools."
//   },
//   {
//     img: img3,
//     title: "Drive Efficiency with Technology.",
//     desc: "Modern solutions designed to improve business productivity and safety."
//   }
// ];

// const TechVisionLogin = () => {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % slides.length);
//     }, 3500);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <div className="tv-main-container">

//       {/* LEFT SIDE */}
//       <div className="tv-left">

//         {/* SLIDING IMAGE */}
//         <img 
//           src={slides[index].img} 
//           className="tv-left-bg fade"
//           alt="slider" 
//         />

//         <div className="tv-logo">TechVision</div>

//         {/* SLIDING TEXT */}
//         <div className="tv-left-content fade">
//           <h2>{slides[index].title}</h2>
//           <p>{slides[index].desc}</p>

//           <div className="tv-dots">
//             {slides.map((_, i) => (
//               <span
//                 key={i}
//                 className={`tv-dot ${i === index ? "active" : ""}`}
//                 onClick={() => setIndex(i)}
//               ></span>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* RIGHT SIDE SAME RAHEGA — sirf waha edit karna hai to bolo */}
//       <div className="right-login-page">
//         <div className="tv-right">
//           <div className="tv-login-box">
//             <h3>Login to your account</h3>

//             <div className="tv-gmail-box">
//               <img 
//                 src="https://fonts.gstatic.com/s/i/productlogos/googleg/v6/24px.svg"
//                 width={40}
//               />
//               <span>Continue with Google</span>
//             </div>

//             <div className="tv-divider"><span>or</span></div>

//             <label>Username</label>
//             <input className="tv-input" />

//             <label>Password</label>
//             <input type="password" className="tv-input" />

//             <button className="tv-login-btn">Log In</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TechVisionLogin;
